import { GAME_WIDTH } from '../config.js';
import { scrollTargetX, easeScroll } from './sideScroll.mjs';

// The main camera follows `getTarget()` sideways across a `worldW`-wide world with a soft lag. It
// snaps on attach (a scene never starts by panning in), keeps sub-pixel scroll (whole-pixel steps
// read as stutter), and never uses setBounds (that breaks the top-left retina zoom — see OutsideScene).
export function attachSideScroll(scene, { worldW, getTarget }) {
  const cam = scene.cameras.main;
  cam.stopFollow();
  cam.roundPixels = false;
  cam.scrollX = scrollTargetX(getTarget().x, worldW, GAME_WIDTH);
  return {
    update(dtMs) {
      cam.scrollX = easeScroll(cam.scrollX, scrollTargetX(getTarget().x, worldW, GAME_WIDTH), dtMs);
    },
  };
}
